module.exports = __webpack_public_path__ + "img/carruselLazyLoad.ad2a0ef7.jpg";